import selectFolderAndRow from '../orchestrators/selectFolderAndRow';
export default function mailRowRouteHandler(parameters) {
    var folderId = parameters.folderId, rowId = parameters.rowId;
    selectFolderAndRow(folderId, rowId);
}
//# sourceMappingURL=mailRowRouteHandler.js.map